<div id="loadingScreenWrap" *ngIf="loader$ | async">
    <div class="loadingScreen bg-black"></div>
    <picture>
      <source srcset="assets/animate/Loading-checkmark_large.gif" media="(min-width: 1400px)" />
      <source srcset="assets/animate/Loading-checkmark_desktop.gif" media="(min-width: 1200px)" />
      <img
        src="assets/animate/Loading-checkmark_mobile_1.gif"
        alt=""
        width="186"
        height="186"
        decoding="async"
        fetchpriority="high"
      />
    </picture>
    <span class="sr-only">Loading...</span>
</div>
